import { render, staticRenderFns } from "./AckList.vue?vue&type=template&id=5fbbb51c"
import script from "./AckList.vue?vue&type=script&lang=js"
export * from "./AckList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports